import { useQuery, useQueryClient, useMutation } from '@tanstack/react-query';
import { NakshatramCalendarService } from './nakshatram-calendar.service';

export const useGetNakshatramCalendar = (
  fromDate,
  toDate,
  nakshatramId = undefined,
  page = 1,
  limit = 10
) => {
  return useQuery({
    queryKey: [
      'nakshatramCalendarService.getAll',
      fromDate,
      toDate,
      nakshatramId,
      page,
      limit,
    ],
    queryFn: () =>
      NakshatramCalendarService.getAll(
        fromDate,
        toDate,
        nakshatramId,
        page,
        limit
      ),
  });
};

export const useCreateNakshatramCalendarEntry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ date, nakshatramIds }) =>
      NakshatramCalendarService.createCalendarEntry(date, nakshatramIds),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramCalendarService.getAll');
    },
  });
};

export const useDeleteNakshatramCalendarEntry = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: ({ nakshatramCalendarId }) =>
      NakshatramCalendarService.deleteNakshatram(nakshatramCalendarId),
    onSuccess: () => {
      queryClient.invalidateQueries('nakshatramCalendarService.getAll');
    },
  });
};
